<template>
  <!-- Imporing application componet-->
  <ApplicationForm v-if="leadData?.result?.lead!=undefined"></ApplicationForm>
</template>

<script>
import ApplicationForm from "../../components/Profile/Application.vue";
import { mapState } from "vuex";
export default {
  name: "Application View",
  components: { ApplicationForm },
  computed: mapState(["leadData"]),
  mounted() {
    if(this.leadData?.result?.lead != undefined){
     if(this.leadData.result.lead[0].attorney_id !=null && this.leadData.result.lead[0].attorney_id !=undefined)
      {
        this.$toast.success("Application already submitted");
        this.$router.push("/home");
      }
    }else{
        if(this.leadData?.result?.lead == undefined){
          this.$toast.error("Please login first!");
          this.$router.push("/unauthorized");
        }
      }
  },
};
</script>
